import {
  ApplicationRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import {
  DashboardConfiguration,
  MapConfiguration,
} from 'src/app/models/utility.model';
import { UtilityService } from 'src/app/services/utility.service';
import { Router } from '@angular/router';
import { Translation } from 'src/app/models/translation.model';
import { CurrencyList } from 'src/app/models/currency.model';
import { CountryList } from 'src/app/models/country.model';
import { LanguageList } from 'src/app/models/language.model';
import { BlobStorageService } from 'src/app/_modules/shared/_services/blob-storage.service';
import { ContainerNames } from 'src/app/models/containerNames.model';

@Component({
  selector: 'app-add-utility',
  templateUrl: './add-utility.component.html',
  styleUrls: ['./add-utility.component.scss'],
})
export class AddUtilityComponent implements OnInit {
  @ViewChild('utilityImage') utilityImageInput: ElementRef;
  @ViewChild('closeModal') closeModal: ElementRef;
  @ViewChild('serviceImage') serviceImageInput: ElementRef;
  serviceImage: File | null;
  saveDisabled: boolean = true;
  utilityImage: File | null;
  serviceRequestImageUrl: string | null;
  blobUrl: string = '';
  name: string = '';
  acronym: string = '';
  hasImage: boolean = false;
  imageSrc: string | ArrayBuffer;
  color: string = '';
  selectedConfiguration: DashboardConfiguration[] = [];
  translationKeys: Translation[] = [];
  selectedTranslation: Translation = new Translation();

  country: string = '';
  language: string = '';

  commission: string = '';
  reform: string = '';
  regulation: string = '';
  management: string = '';

  firstName: string = '';
  lastName: string = '';
  eMail: string = '';

  bankName: string = '';
  accountName: string = '';
  accountNumber: string = '';
  currencyList = CurrencyList;
  countryList = CountryList;
  languageList = LanguageList;
  currency: string | undefined = '';
  public Configuration = DashboardConfiguration;
  mapConfiguration?: MapConfiguration;
  isMapVisible: boolean = false;
  isSelectedAreasForMobileLimited: boolean = false;
  maximumSelectedAreasForMobile: number = 1;
  @ViewChild('closeMapModalBtn') closeMapModalBtn: ElementRef;

  utilityList: { key: number; value: string }[] = [];
  selectedUtilityId: number | null = null;

  constructor(
    private location: Location,
    private toastr: ToastrService,
    private utilityService: UtilityService,
    private router: Router,
    private blobStorageService: BlobStorageService,
    private appRef: ApplicationRef,
  ) {}

  ngOnInit(): void {
    this.blobStorageService.setContainer(ContainerNames.KYC);
    this.getUtilityKeys();
    this.getUtilities();
  }

  activeCard = 1;
  readonly cardsCount = 5;

  cancelClicked() {
    this.location.back();
  }

  getUtilityKeys() {
    var jsonTranslations = localStorage.getItem('translation');
    var data = JSON.parse(jsonTranslations!);
    this.translationKeys = data;
  }

  save() {
    let obj = {
      name: this.name,
      currency: this.currency,
      colorCode: this.color,
      dashboardConfiguration: this.selectedConfiguration,
      translations: this.translationKeys,
      kycConsentConfiguration: {
        regulatoryCommission: this.commission,
        electricityReform: this.reform,
        networkRegulation: this.regulation,
        electricityManagement: this.management,
        country: this.country,
        serviceRequestImageUrl: this.serviceRequestImageUrl,
      },
      contactPerson: {
        firstName: this.firstName,
        lastName: this.lastName,
        eMail: this.eMail,
      },
      bankDetails: {
        bankName: this.bankName,
        accountName: this.accountName,
        accountNumber: this.accountNumber,
      },
      language: this.language,
      country: this.country,
      acronym: this.acronym,
      defaultCaimsCodePatterns: true,
      utilityIdCopyFrom: this.selectedUtilityId,
      mapConfiguration: this.mapConfiguration,
      configurationGenerations: [],
      isSelectedAreasForMobileLimited: this.isSelectedAreasForMobileLimited,
      maximumSelectedAreasForMobile: this.isSelectedAreasForMobileLimited
        ? this.maximumSelectedAreasForMobile
        : null,
    };
    if (!this.utilityImage) {
      this.toastr.error('Image data is missing');
      return;
    }

    if (
      this.isSelectedAreasForMobileLimited &&
      !this.maximumSelectedAreasForMobile
    ) {
      this.toastr.error(
        'Please provide maximum selected areas for mobile users.',
      );
      return;
    }
    this.utilityService.add(obj, this.utilityImage).subscribe({
      next: (response) => {
        const responseData = response;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.toastr.success(responseData.message);
          setTimeout(() => {
            this.location.back();
          }, 2000);
        } else if (
          responseData?.status === 409 ||
          responseData?.status === 'Conflict'
        ) {
          this.toastr.warning(responseData?.message);
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (error) => {
        console.log(error.message);
        this.toastr.error('Error occured');
      },
    });
  }

  selectCountry(e: any) {
    if (e.target.value != '') {
      this.country = e.target.value;
    } else {
      this.country = '';
    }
  }

  selectLanguage(e: any) {
    if (e.target.val != '') {
      this.language = e.target.value;
    } else {
      this.language = '';
    }
  }

  isLimited: boolean = false;
  limitValue: number | null = null;

  setLimited() {
    this.isLimited = true;

    // default value ako je null
    if (!this.limitValue || this.limitValue < 1) {
      this.limitValue = 1;
    }
  }

  setUnlimited() {
    this.isLimited = false;
    this.limitValue = null;
  }

  validateLimit() {
    if (!this.limitValue || this.limitValue < 1) {
      this.limitValue = 1;
    }
  }

  blockInvalidKeys(event: KeyboardEvent) {
    if (event.key === '-' || event.key === 'e') {
      event.preventDefault();
    }
  }

  addNewSubdomain(utilityId: number) {
    this.utilityService.addNewSubdomain(utilityId).subscribe({
      next: (response) => {
        if (response?.status === 'Pending') {
          this.toastr.info(response?.message);
          this.router.navigate(['/utility-management']);
        }
      },
      error: (error) => {
        console.log(error.message);
        this.toastr.error('Error occured');
      },
    });
  }

  setActiveCard(activeCard: number): void {
    this.activeCard = activeCard;
    this.saveDisabled = true;
  }
  removeImage() {
    this.blobUrl = '';
    this.utilityImage = null;
    this.hasImage = false;
  }
  selectCurrency(e: any) {
    if (e.target.value != '') {
      this.currency = e.target.value;
    } else {
      this.currency = undefined;
    }
  }
  continue(): void {
    if (this.activeCard === 1) {
      if (this.color === '') {
        this.toastr.warning('Please select color code.');
        return;
      }
      if (this.name === '') {
        this.toastr.warning('Please fill out the name field.');
        return;
      }

      if (this.utilityImage === undefined || this.utilityImage === null) {
        this.toastr.warning('Please add the utility logo.');
        return;
      }
    }
    if (this.activeCard === 2) {
      if (this.selectedConfiguration.length === 0) {
        this.toastr.warning('Please select some Assets/Operations.');
        return;
      }
    }
    this.activeCard++;
    if (this.activeCard > this.cardsCount) {
      this.saveDisabled = false;
    }
  }

  isChecked(listConfig: any) {
    let checked = true;
    listConfig.forEach((val: any) => {
      if (!this.selectedConfiguration.includes(val)) checked = false;
    });
    return checked;
  }
  isSelected(config: any) {
    let checked = 'On';
    if (!this.selectedConfiguration.includes(config)) {
      checked = 'Off';
    }
    return checked;
  }
  fileBrowserHandler($event: any) {
    this.utilityImage = $event.target.files.item(0);
    if (
      this.utilityImage?.type != 'image/png' &&
      this.utilityImage?.type != 'image/jpg' &&
      this.utilityImage?.type != 'image/jpeg'
    ) {
      this.toastr.warning('Only PNG/JPG/JPEG images are allowed');
      if (this.utilityImageInput?.nativeElement) {
        this.utilityImageInput.nativeElement.value = '';
      }
    } else {
      this.hasImage = true;
      const reader = new FileReader();
      var width = 0;
      var height = 0;
      reader.onload = (e) => {
        this.imageSrc = reader.result!;
        const img = new Image();
        img.src = e.target!.result as string;

        img.onload = () => {
          width = img.width;
          height = img.height;
          var ratio = width / height;
          if (ratio > 2 || ratio < 0.5) {
            this.toastr.warning('Unsuported image size.');
            this.imageSrc = '';
            this.hasImage = false;
            this.utilityImage = null;
            this.appRef.tick();
          }
        };
      };
      reader.readAsDataURL(this.utilityImage!);
    }
  }

  onChange(configuration: any, event: any = null) {
    configuration.forEach((value: any) => {
      if (event != null) {
        if (!this.isChecked([value]) && event.target.checked == true)
          this.selectedConfiguration.push(value);
        else if (this.isChecked([value]) && event.target.checked == false)
          this.selectedConfiguration = this.selectedConfiguration.filter(
            (item: any) => item != value,
          );
      } else {
        if (this.selectedConfiguration.includes(value))
          this.selectedConfiguration = this.selectedConfiguration.filter(
            (item: any) => item != value,
          );
        else this.selectedConfiguration.push(value);
      }
    });
  }
  onFileDropped($event: any) {
    this.utilityImage = $event.item(0);
    if (
      this.utilityImage?.type != 'image/png' &&
      this.utilityImage?.type != 'image/jpg' &&
      this.utilityImage?.type != 'image/jpeg'
    ) {
      this.toastr.warning('Only PNG/JPG/JPEG images are allowed');
      if (this.utilityImageInput?.nativeElement) {
        this.utilityImageInput.nativeElement.value = '';
      }
    } else {
      this.hasImage = true;
      const reader = new FileReader();
      var width = 0;
      var height = 0;
      reader.onload = (e) => {
        this.imageSrc = reader.result!;
        const img = new Image();
        img.src = e.target!.result as string;

        img.onload = () => {
          width = img.width;
          height = img.height;
          var ratio = width / height;
          if (ratio > 2 || ratio < 0.5) {
            this.toastr.warning('Unsuported image size.');
            this.imageSrc = '';
            this.hasImage = false;
            this.utilityImage = null;
            this.appRef.tick();
          }
        };
      };
      reader.readAsDataURL(this.utilityImage!);
    }
  }

  selectTranslation(item: Translation) {
    this.selectedTranslation = { ...item };
  }

  saveTranslation() {
    var indexToChange = this.translationKeys.findIndex(
      (item) => item.key == this.selectedTranslation.key,
    );
    this.translationKeys[indexToChange] = this.selectedTranslation;
    this.closeModal?.nativeElement?.click();
  }

  selectUtility(event: Event) {
    const value = (event.target as HTMLSelectElement).value;
    this.selectedUtilityId = value ? +value : null;
  }

  getUtilities() {
    this.utilityService.getUtilitiesForSelect().subscribe({
      next: (data) => {
        this.utilityList = data.data;
      },
      error: (error) => console.log(error.statusText),
    });
  }

  onAcronymChange(value: string) {
    const cleaned = value
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, '')
      .substring(0, 10);

    this.acronym = cleaned;
  }

  allowOnlyAlphaNumeric(event: KeyboardEvent) {
    const char = event.key.toUpperCase();
    const isValid = /^[a-zA-Z0-9]$/.test(char);
    if (!isValid) {
      event.preventDefault();
    }
  }

  onMapConfigurationSaved(config: MapConfiguration) {
    this.mapConfiguration = config;

    if (this.closeMapModalBtn) {
      this.closeMapModalBtn.nativeElement.click();
    }
  }

  onServiceFileDropped($event: any) {
    this.serviceImage = $event.item(0);
    if (
      this.serviceImage?.type != 'image/png' &&
      this.serviceImage?.type != 'image/jpg' &&
      this.serviceImage?.type != 'image/jpeg'
    ) {
      this.toastr.warning('Only PNG/JPG/JPEG images are allowed');
      if (this.serviceImageInput?.nativeElement) {
        this.serviceImageInput.nativeElement.value = '';
      }
    } else {
      const reader = new FileReader();
      const maxSize = 2 * 1024 * 1024;
      if (this.serviceImage && this.serviceImage.size > maxSize) {
        this.toastr.warning('Image must be smaller than 2 MB.');
        this.imageSrc = '';
        this.serviceImage = null;
        this.appRef.tick();
        return;
      }

      this.serviceImageUpload(this.serviceImage);
    }
  }
  serviceFileBrowserHandler($event: any) {
    this.serviceImage = $event.target.files.item(0);
    if (
      this.serviceImage?.type != 'image/png' &&
      this.serviceImage?.type != 'image/jpg' &&
      this.serviceImage?.type != 'image/jpeg'
    ) {
      this.toastr.warning('Only PNG/JPG/JPEG images are allowed');
      if (this.serviceImageInput?.nativeElement) {
        this.serviceImageInput.nativeElement.value = '';
      }
    } else {
      const maxSize = 2 * 1024 * 1024;
      if (this.serviceImage && this.serviceImage.size > maxSize) {
        this.toastr.warning('Image must be smaller than 2 MB.');
        this.imageSrc = '';
        this.serviceImage = null;
        this.appRef.tick();
        return;
      }
      this.serviceImageUpload(this.serviceImage);
    }
  }
  removeServiceImage() {
    this.serviceImage = null;
    this.serviceRequestImageUrl = null;
  }
  serviceImageUpload(data: File | null) {
    if (data === null) return;

    this.blobStorageService.uploadFile(
      data,
      data.name,
      (response) => {
        this.serviceRequestImageUrl = response;
      },
      (error) => {
        this.toastr.error('Failed to upload Service request image');
      },
    );
  }
}
